// components/InventoryList.js
import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth  } from '../contexts/AuthContext';
import axios from "axios";
import AccountTree from './AccountTree';
import AcccountStatus  from './widgets/AccountsStatus';

const apiUrl = window._env_?.REACT_APP_API_URL || "https://app.mylocaleventrentals.com/api";

const AccountsList = () => {
  const [accounts, setAccounts] = useState([]);
  const { logout } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      logout();
      navigate('/login');
      return;
    }
    const fetchAccounts = async () => {
      const token = localStorage.getItem('token');
      const res = await axios.get(`${apiUrl}/account/tree`, {
        headers: { 'x-auth-token': token }
      });
      setAccounts(res.data.data);
    };
    fetchAccounts();
  }, []);

  return (
    <div className='p-6 bg-white rounded shadow'>
      <div className='m-3 font-bold'>
        <AcccountStatus />
      </div>
      <h3>Chart of Accounts</h3>
      <AccountTree accounts={accounts} />

      
    </div>
  );
};
export default AccountsList;